import colors from '@pickles/shared/utils/colors';
import styled from 'styled-components';
import sizes from '../../../../util/sizes';

export const PromoBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 84px;
  max-width: ${sizes.XL};

  > :not(:first-child) {
    margin-left: 80px;
  }

  @media (max-width: ${sizes.S}) {
    flex-direction: column;

    > :not(:first-child) {
      margin-top: 40px;
      margin-left: 0;
    }
  }
`;

export const PromoBlockPromoText = styled.p`
  flex: 0.5;
  font-weight: 600;
  font-size: 36px;
  line-height: 130%;
  max-width: ${sizes.XL};
  color: ${colors.rhino_black};
`;

export const PromoBlockRightContainer = styled.div`
  flex: 0.5;
  display: flex;
  flex-direction: column;
  max-width: ${sizes.XL};
`;

export const PromoBlockTitle = styled.p`
  font-weight: 600;
  font-size: 24px;
  line-height: 150%;
  letter-spacing: -0.01em;
  color: ${colors.san_juan_grey};
  max-width: ${sizes.XL};
`;

export const PromoBlockDescription = styled.div`
  margin-top: 16px;
  color: ${colors.san_juan_grey};
  max-width: ${sizes.XL};
`;

export const OpenPositionsContainer = styled.div`
  margin-top: 112px;
  margin-bottom: 84px;
  width: 100%;
  max-width: ${sizes.XL};
`;

export const OpenPositionsTitle = styled.p`
  font-weight: 600;
  font-size: 36px;
  line-height: 130%;
  color: ${colors.rhino_black};
  max-width: ${sizes.XL};
`;

export const OpenPositionsHolder = styled.div`
  margin-top: 14px;
  max-width: ${sizes.XL};
`;

export const OpenPosition = styled.div`
  padding: 28px 0;
  border-bottom: 1px solid #d6dadf;
  display: flex;
  justify-content: space-between;
  max-width: ${sizes.XL};

  @media (max-width: ${sizes.S}) {
    flex-direction: column;
  }
`;

export const OpenPositionRole = styled.p`
  font-weight: 600;
  font-size: 20px;
  line-height: 150%;
  color: ${colors.rhino_black};
  max-width: ${sizes.XL};
`;

export const ViewJob = styled.a`
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
  width: fit-content;
  color: ${colors.blumine_main_blue};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  white-space: pre;
  max-width: ${sizes.XL};

  &:after {
    content: '';
    display: inline-block;
    background: url(/icons/arrowBlueRight.svg) no-repeat;
    background-position: center;
    width: 40px;
    height: 12px;
    display: inline-flex;
    align-items: center;
  }

  @media (max-width: ${sizes.S}) {
    margin-top: 24px;
  }
`;

export const JobDescriptionContainer = styled.div`
  margin: 36px auto 112px;
  width: 770px;
  max-width: ${sizes.XL};

  ul {
    list-style-position: outside;
    margin-left: 12px;
  }

  @media (max-width: ${sizes.M}) {
    width: 100%;
    padding-left: 40px;
    padding-right: 40px;
  }

  @media (max-width: ${sizes.S}) {
    width: 100%;
  }

  @media (max-width: ${sizes.XS}) {
    width: 100%;
  }
`;

export const JobDescriptionTitle = styled.p`
  font-weight: 600;
  font-size: 36px;
  line-height: 130%;
  color: ${colors.rhino_black};
  max-width: ${sizes.XL};
`;
